import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { css } from '@emotion/react'
import Link from 'next/link'

import { Logo } from '@microsites/components/Logo/Logo'
import {
  LargeAndAbove,
  propWithBreakpoints,
  SmallAndAbove,
} from '@microsites/components/MediaQuery'

/**
 *
 */
function Sidebar() {
  const { t } = useTranslation()

  return (
    <SmallAndAbove
      css={[
        css`
          display: flex;
          flex-direction: column;
          height: 100vh;
          padding-bottom: 32px;
          position: sticky;
          top: 0;
          z-index: 3;
        `,
        propWithBreakpoints('width', ['unset', '70px', '70px', '225px']),
        propWithBreakpoints('margin-right', ['0', '0', '0', '50px']),
        propWithBreakpoints('padding-top', ['0', '0', '0', '10px']),
      ]}
    >
      <div
        css={css`
          display: flex;
          flex: 1;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-end;
        `}
      >
        <LargeAndAbove
          css={[
            css`
              width: 100%;
            `,
          ]}
        >
          <div
            css={css`
              padding-top: 16px;
              padding-bottom: 16px;
              border-top: 1px solid rgba(255, 255, 255, 0.25);
            `}
          >
            <div
              css={css`
                display: flex;
              `}
            >
              <span
                css={css`
                  font-size: 14px;
                `}
              >
                <Trans
                  i18nKey="Powered by <0>Firework</0>"
                  components={[
                    <Logo
                      key="0"
                      width={90}
                      css={[
                        css`
                          margin-top: 4px;
                          margin-left: 8px;
                          width: 90px;
                        `,
                      ]}
                    />,
                  ]}
                />
              </span>
            </div>
          </div>
          <div
            css={css`
              color: #9b9b9b;
              font-size: 12px;
              a {
                color: inherit;
                margin-right: 0.5rem;
              }
            `}
          >
            <div
              css={css`
                display: flex;
              `}
            >
              <Link href="/terms">{t('next:Terms')}</Link>
              <Link href="/privacy">{t('next:Privacy')}</Link>
              <Link href="/community_guidelines">{t('next:Guidelines')}</Link>
            </div>
          </div>
        </LargeAndAbove>
      </div>
    </SmallAndAbove>
  )
}

export default Sidebar
